<template>
    <v-card
        id="skeleton"
        class="rounded-xl pa-2"
        elevation="0"
        style="width: 100vw"
        :color="img ? 'transparent' : ''"
    >
        <div v-if="img">
            <v-img
                :src="img"
                contain
                style="width: auto; height: auto;"
            >
            </v-img>
        </div>
        <v-row v-else class="pa-4">
            <v-col cols="12" md="2">
                <v-row>
                    <v-skeleton-loader
                        v-bind="attrs"
                        type="actions"
                    ></v-skeleton-loader>
                </v-row>
                <v-row>
                    <v-skeleton-loader
                        v-bind="attrs"
                        type="actions"
                    ></v-skeleton-loader>
                </v-row>
                <v-row>
                    <v-skeleton-loader
                        v-bind="attrs"
                        type="actions"
                    ></v-skeleton-loader>
                </v-row>
                <v-row>
                    <v-skeleton-loader
                        v-bind="attrs"
                        type="actions"
                    ></v-skeleton-loader>
                </v-row>
            </v-col>
            <v-col cols="12" md="10">
                <v-row>
                    <v-col cols="12" md="6">
                        <v-skeleton-loader
                            v-bind="attrs"
                            type="article, table-heading,card-heading"
                        ></v-skeleton-loader>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-skeleton-loader
                            v-bind="attrs"
                            type="article, table-heading,card-heading"
                        ></v-skeleton-loader>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-skeleton-loader
                            v-bind="attrs"
                            type="image, table-heading,card-heading"
                        ></v-skeleton-loader>
                    </v-col>
                    <v-col cols="12" md="8">
                        <v-skeleton-loader
                            v-bind="attrs"
                            type="image, table-heading,card-heading"
                        ></v-skeleton-loader>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>

export default {
    name: 'LoadingSkeletons',
    data: () => ({
        attrs: {},
    }),
    props: {
        image: {
            type: String,
            default: null,
        },
    },
    computed: {
        img() {
            return this.image
        },
    },
};
</script>

<style scoped>
.container {
    --bg: $bg;
    --primary: #ff00bfd5;
    --secondary: #00ff73;
    -webkit-font-smoothing: antialiased;
    color: #fff;
    font-family: HelveticaNeue-Light, Helvetica Neue Light, Helvetica Neue,
        Helvetica, Arial, Lucida Grande, sans-serif;
    font-size: 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    width: 500px;
    height: 500px;
    position: fixed;
    z-index: 1;
    top: 50%;
    left: 50%;
    /* bring your own prefixes */
    transform: translate(-50%, -50%);
}

@-webkit-keyframes grow {
    0%,
    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    50% {
        -webkit-transform: scale(0.25);
        transform: scale(0.25);
    }
}
@keyframes grow {
    0%,
    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    50% {
        -webkit-transform: scale(0.25);
        transform: scale(0.25);
    }
}

.merge {
    -webkit-animation: spin 1.33333s infinite linear;
    animation: spin 1.33333s infinite linear;
    height: 30px;
    position: relative;
    width: 30px;
}
.merge:after,
.merge:before {
    content: '';
    height: 120px;
    width: 120px;
    -webkit-animation: grow 2s infinite ease backwards;
    animation: grow 2s infinite ease backwards;
    border-radius: 100%;
    background: var(--primary);
    opacity: 0.75;
    position: absolute;
    -webkit-transform-origin: -200% -80%;
    transform-origin: -200% -80%;
}

.merge:before {
    background: var(--secondary);
    -webkit-transform-origin: 200% 80%;
    transform-origin: 200% 80%;
}

@-webkit-keyframes spin {
    to {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@keyframes spin {
    to {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
</style>
